import { Component, OnInit, Input, EventEmitter, Output, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { DateInputModel } from './date-input.model';
import { BsLocaleService } from 'ngx-bootstrap';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { plLocale } from 'ngx-bootstrap/locale';
defineLocale('pl', plLocale); 


@Component({
  selector: 'smp-date-input',
  //template: `<p *ngIf="element">{{ element.name }}<p> `
  templateUrl: './date-input.component.html',
})
export class DateInputComponent implements OnInit { 
  @Input() element: DateInputModel;
  @Input() withTime: boolean;
  @Input() showClearButton: boolean = false;
  @Input() showTextInfo: boolean = true;
  @Output() validated = new EventEmitter<boolean>(false);
  public dateFormat = 'dd.MM.yyyy';

  // private elementValue: FormControl;
  // private form: FormGroup;
  // private showDateTime = false;
  // private fullDateTime: Date;
  // private fullDateTimeInString = '';
  // private date: Date;
  // private time = new Date();

  locale = 'pl'; 

  bsConfig = {
    containerClass: 'theme-angle'//,
    //dateInputFormat: 'YYYY-MM-DD'
  }

  constructor(private localeService: BsLocaleService) { 
    this.localeService.use(this.locale);
  }

  ngOnInit() {
    //this.time.setSeconds(0);
        
    //this.withTime = this.element.withTime;       
    //this.elementValue = this.builder.control('', this.createValidators());

    //this.elementValue.valueChanges.subscribe(() => this.onValueChange());
    //this.form = this.builder.group({ 'elementValue': this.elementValue });

    
    
  }

  private onValueChange(event) {
    //if (this.elementValue.valid) {    
      // this.element.valueStr = this.elementValue.value.toLocaleString('pl-PL',{year:"numeric",month:"2-digit", day:"2-digit"});
      // this.element.value = this.elementValue.value;
      // this.validated.emit(this.elementValue.valid);
    //}
      if(event == null) {
        this.element.value = null;
        this.validated.emit(true);
        return;
      }

      this.element.valueStr = event.toLocaleString('pl-PL');
      this.element.value = event;          
      //this.element.value.setUTCHours(this.element.value.getUTCHours() - (this.element.value.getTimezoneOffset() / 60));

      this.validated.emit(true);
  }

  private clear() {
    this.element.value = null;
    this.validated.emit(true);
  }

  // private setToday() {
  //   this.element.value = new Date();
  //   this.validated.emit(true);
  // }

  // private createValidators(): ValidatorFn {
  //   if (this.element && this.element.isRequired) {
  //      return Validators.compose([Validators.required]);
  //   }
  // }

  // private getFullDateTime() {
  //   if (this.date) {
  //     this.fullDateTime = this.date;
  //     if (this.withTime) {
  //       this.fullDateTime.setHours(this.time.getHours());
  //       this.fullDateTime.setMinutes(this.time.getMinutes());
  //       this.element.valueStr = this.fullDateTime.toLocaleString('pl-PL',{year:"numeric",month:"2-digit", day:"2-digit"});
  //       this.element.value = this.fullDateTime
  //       this.fullDateTimeInString = this.fullDateTime.toLocaleString();
  //     } else {
  //       this.element.valueStr = this.fullDateTime.toLocaleDateString('pl-PL',{year:"numeric",month:"2-digit", day:"2-digit"});
  //       this.element.value = this.fullDateTime;
  //       this.fullDateTimeInString = this.fullDateTime.toLocaleDateString('pl-PL',{year:"numeric",month:"2-digit", day:"2-digit"});
  //     }
  //   } else {
  //     this.fullDateTimeInString = this.element.valueStr;
  //   }
  // }

  // private clearDate() {
  //   setTimeout(() => {
  //     this.date = this.fullDateTime = null;
  //     this.time = new Date();
  //     this.time.setSeconds(0);
  //     this.element.valueStr = '';
  //     this.showDateTime = false;
  //     this.getFullDateTime();
  //   });
  // }

  // private setDateTime() {    
  //   setTimeout(() => this.getFullDateTime());
  // } 
}
